import { render, staticRenderFns } from "./MediaGridLayout.vue?vue&type=template&id=2a54950f&"
import script from "./MediaGridLayout.vue?vue&type=script&lang=js&"
export * from "./MediaGridLayout.vue?vue&type=script&lang=js&"
import style0 from "./MediaGridLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports